import React, { useEffect, useState } from "react";
import { getMembership } from "../../api/user";
import { resolveMembershipDisplay } from "../../utils/membershipUtils";
import "./styles/MembershipInfo.scss";

/**
 * Issue #70: マイページに表示するメンバーシップの更新日の帯。
 *
 * WeeklyRanking と同じ「自分でフェッチする小コンポーネント」パターン。
 * 表示できる日付が無い場合（未決済・期間切れ・解約・データ未同期・取得失敗）は
 * プレースホルダを出さず、帯自体を描画しない。
 * 仕様: docs/plans/202608/70-membership-renewal-date.md
 */
const MembershipInfo = () => {
  const [membership, setMembership] = useState(null);

  useEffect(() => {
    getMembership()
      .then((res) => {
        if (res && res.status === 200) setMembership(res.data);
      })
      .catch(() => {});
  }, []);

  const display = resolveMembershipDisplay(membership);
  if (!display) return null;

  return (
    <section className="membership-info">
      <span className="membership-info__label">{display.label}</span>
      <span className="membership-info__value">{display.value}</span>
    </section>
  );
};

export default MembershipInfo;
